import { render, staticRenderFns } from "./ServiceDialog.vue?vue&type=template&id=5b06f660&scoped=true"
import script from "./ServiceDialog.vue?vue&type=script&lang=js"
export * from "./ServiceDialog.vue?vue&type=script&lang=js"
import style0 from "./ServiceDialog.vue?vue&type=style&index=0&id=5b06f660&prod&lang=css"
import style1 from "./ServiceDialog.vue?vue&type=style&index=1&id=5b06f660&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b06f660",
  null
  
)

export default component.exports